import React from "react";
import Constants from "../../../constants/text-constants";
import PropTypes from "prop-types";
import LocationForm from "../../molecules/LocationForm";
import LocationHandler from "../../../services/api/locationHandler";
import { useMst } from "../../../hooks/useMst";

const EditLocation = (props) => {
    const { locationStore } = useMst();
    const { onClose, location } = props;

    const onSaveEditLocation = async (editedLocation) => {
        try {
            await LocationHandler.editLocation(editedLocation);

            // Edit location in store
            locationStore.editLocation(editedLocation);
            onClose();
        } catch {
            return false;
        }
    }

    return (
        <LocationForm
            disableCode={true}
            saveButtonText={Constants.SAVE}
            location={location}
            onCancel={onClose}
            onSave={onSaveEditLocation}
            title={Constants.EDIT_LOCATION}
            subTitle={Constants.TELL_US_WHERE_CALLS}
            failureMessage={Constants.FAILED_TO_SAVE}
        />
    );
}

EditLocation.propTypes = {
    onClose: PropTypes.func,
    location: PropTypes.object,
};

EditLocation.defaultProps = {
    location: {
        code: "",
        description: "",
        phoneNumber: "",
    },
};

export default EditLocation;